export const PasswordStrength = {
  WEAK: 1,
  MEDIUM: 2,
  STRONG: 3,
} as const;

export type PasswordStrengthTypes =
  (typeof PasswordStrength)[keyof typeof PasswordStrength];

export type PasswordStrengthEvaluator = (
  password: string,
) => PasswordStrengthTypes;
